// Meta Pixel Helper — Pixel ID: 1206028461436742

declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

export function initMetaPixel() {
  if (typeof window === 'undefined' || window.fbq) return

  const f = window
  const b = document
  const n = 'script'

  // eslint-disable-next-line
  const fbq = function (...args: unknown[]) {
    // @ts-ignore
    fbq.callMethod ? fbq.callMethod(...args) : fbq.queue.push(args)
  } as any
  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = [] as unknown[][]

  f.fbq = fbq
  f._fbq = fbq

  const script = b.createElement(n)
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = b.getElementsByTagName(n)[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)

  window.fbq('init', '1206028461436742')
  window.fbq('track', 'PageView')
  window.fbq('track', 'ViewContent', {
    content_name: 'La Botica de la Abuela Moderna — Landing Page',
    content_type: 'product',
    value: 6.39,
    currency: 'USD',
  })
}

export function trackInitiateCheckout() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'InitiateCheckout', {
      content_name: 'La Botica de la Abuela Moderna',
      content_type: 'product',
      value: 6.39,
      currency: 'USD',
    })
  }
}
